// pendenciaService.js
import axios from "axios";

const API_URL = `${process.env.REACT_APP_BASE_URL}/pendencias`;

const getToken = () => localStorage.getItem("token");

export const getPendencias = async (page = 1, filters = {}) => {
  const token = getToken();
  try {
    const response = await axios.get(API_URL, {
      params: { page, ...filters },
      headers: { "x-auth-token": token }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar pendências:", error);
    throw error;
  }
};

export const getPendenciaById = async id => {
  const token = getToken();
  try {
    const response = await axios.get(`${API_URL}/${id}`, {
      headers: { "x-auth-token": token }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar pendência por ID:", error);
    throw error;
  }
};

export const createPendencia = async novaPendencia => {
  const token = getToken();
  try {
    const response = await axios.post(API_URL, novaPendencia, {
      headers: { "x-auth-token": token }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao criar pendência:", error);
    throw error;
  }
};

export const updatePendencia = async (pendenciaId, pendenciaAtualizada) => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${API_URL}/${pendenciaId}`,
      pendenciaAtualizada,
      {
        headers: { "x-auth-token": token }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar pendência:", error);
    throw error;
  }
};

export const deletePendencia = async pendenciaId => {
  const token = getToken();
  try {
    const response = await axios.delete(`${API_URL}/${pendenciaId}`, {
      headers: { "x-auth-token": token }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao deletar pendência:", error);
    throw error;
  }
};

export const uploadFotos = async (pendenciaId, arquivos) => {
  if (!Array.isArray(arquivos)) arquivos = [arquivos];
  const token = getToken();
  const formData = new FormData();
  arquivos.forEach(file => formData.append("fotos", file));
  try {
    const response = await axios.post(
      `${API_URL}/${pendenciaId}/fotos`,
      formData,
      {
        headers: {
          "x-auth-token": token,
          "Content-Type": "multipart/form-data"
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao fazer upload das fotos:", error);
    throw error;
  }
};

export const deleteFoto = async (pendenciaId, nomeFoto) => {
  const token = getToken();
  try {
    const response = await axios.delete(
      `${API_URL}/${pendenciaId}/fotos/${nomeFoto}`,
      {
        headers: { "x-auth-token": token }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao deletar a foto:", error);
    throw error;
  }
};

export const uploadDocumentos = async (pendenciaId, arquivos) => {
  if (!Array.isArray(arquivos)) arquivos = [arquivos];
  const token = getToken();
  const formData = new FormData();
  arquivos.forEach(file => formData.append("documentos", file));
  try {
    const response = await axios.post(
      `${API_URL}/${pendenciaId}/documentos`,
      formData,
      {
        headers: {
          "x-auth-token": token,
          "Content-Type": "multipart/form-data"
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao fazer upload dos documentos:", error);
    throw error;
  }
};

export const deleteDocumento = async (pendenciaId, nomeDocumento) => {
  const token = getToken();
  try {
    const response = await axios.delete(
      `${API_URL}/${pendenciaId}/documentos/${nomeDocumento}`,
      {
        headers: { "x-auth-token": token }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao deletar o documento:", error);
    throw error;
  }
};
